import { render, staticRenderFns } from "./NottinghamListing.vue?vue&type=template&id=4bfa67bc"
import script from "./NottinghamListing.vue?vue&type=script&lang=js"
export * from "./NottinghamListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports